import React from 'react';
import {
  ServiceCentreHyperlink,
  TelephoneContactNumberHyperlink,
} from 'components/Hyperlinks';
import TemplateErrorPage from './TemplateErrorPage/TemplateErrorPage';

const CustomBusinessErrorPage: React.FC = () => {
  return (
    <TemplateErrorPage
      pageTitle="Sorry, you cannot proceed online"
      defaultAlertTitle='Our system is temporarily unavailable'
      analyticsErrorType='business error'
      contactDescription={contactDescription}
    />
  );
};

export default CustomBusinessErrorPage;

const contactDescription = (
  <p>
    Please check your details are correct and try again. Need help? Call{' '}
    <TelephoneContactNumberHyperlink /> or visit a <ServiceCentreHyperlink />. We apologise for any inconvenience.
  </p>
);
